import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import { infoSnack, successSnack, errorSnack } from "../snackbar/snackbarSlice";
// thunkAPI.dispatch(successSnack('Fetched Users'));
// thunkAPI.dispatch(infoSnack('Look at these Users'));
// thunkAPI.dispatch(errorSnack('User error'));
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchClients = createAsyncThunk(
  "clients/fetchClients",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/clients${args.query}`,
        config
      );
      thunkAPI.dispatch(setClientsAmount(response.headers["x-total-count"]));
      thunkAPI.dispatch(setLastQuery(args.query));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching clients list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const filterClients = createAsyncThunk(
  "clients/filterClients",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/clients${args.query}`,
        config
      );

      return await response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreClients = createAsyncThunk(
  "orders/fetchMoreClients",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/clients${args.query}&offset=${args.offset}`,
        config
      );
      // let catQuery = [];
      // if (args.query.includes("categories")) {
      //   let urlSearchParams = new URLSearchParams(args.query);
      //   let params = Object.fromEntries(urlSearchParams.entries());
      //   catQuery = params.categories;
      // }
      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setClientsAmount(response.headers["x-total-count"]));
      // thunkAPI.dispatch(updateCategories(catQuery));
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchClientByID = createAsyncThunk(
  "clients/fetchClientByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/clients/${args.id}`,
        config
      );

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching client data"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteClient = createAsyncThunk(
  "clients/deleteClient",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.delete(
        `${baseURL}/v1/admin/clients/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("Client deleted"));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting client"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateClient = createAsyncThunk(
  "clients/updateClient",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.patch(
        `${baseURL}/v1/admin/clients/${args.id}`,
        args.updatedClient,
        config
      );
      thunkAPI.dispatch(fetchClients({ token: args.token, query: "" }));
      thunkAPI.dispatch(successSnack("Client updated successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating client"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createClient = createAsyncThunk(
  "clients/createClient",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.post(
        `${baseURL}/v1/admin/clients`,
        args.client,
        config
      );
      thunkAPI.dispatch(fetchClients({ token: args.token, query: "" }));
      thunkAPI.dispatch(successSnack("Client created successfully"));

      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating client"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "clients/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreClients(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

const clientsSlice = createSlice({
  name: "clients",
  initialState: {
    client: {},
    clientsList: [],
    clientsFilter: [],
    loading: "idle",
    message: "",
    error: "",
    editing: false,
    clientsAmount: "",
    lastQuery: "",
  },
  reducers: {
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setClientsAmount: (state, action) => {
      state.clientsAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClients.pending, (state) => {
      state.clientsList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchClients.fulfilled, (state, { payload }) => {
      state.clientsList = payload;
      state.clientsFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchClients.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreClients.fulfilled, (state, { payload }) => {
      state.error = "";
      state.clientsList = state.clientsList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreClients.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.clientsList = state.clientsList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(filterClients.pending, (state) => {
      state.clientsFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(filterClients.fulfilled, (state, { payload }) => {
      state.clientsFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(filterClients.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchClientByID.pending, (state) => {
      state.client = {};
      state.loading = "loading";
    });
    builder.addCase(fetchClientByID.fulfilled, (state, { payload }) => {
      state.editing = true;
      state.client = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchClientByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(deleteClient.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(deleteClient.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deleteClient.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateClient.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(updateClient.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updateClient.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createClient.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createClient.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createClient.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const { setLastQuery, setClientsAmount } = clientsSlice.actions;

export const selectClients = createSelector(
  (state) => ({
    clients: state.clients,
    loading: state.clients.loading,
    error: state.clients.error,
    editing: state.clients.editing,
    client: state.clients.client,
    clientsList: state.clients.clientsList,
    clientsAmount: state.clients.clientsAmount,
    lastQuery: state.clients.lastQuery,
  }),
  (state) => state
);
export default clientsSlice.reducer;
